import React from 'react';
import StaticPage, { Section, CardGrid } from './StaticPage';

export default function LandlordResources() {
  return (
    <StaticPage title="Landlord Resources" subtitle="Guides, templates, and tools to help you succeed as a student accommodation provider.">
      <Section title="Getting Started on RentalX">
        <CardGrid items={[
          { title: 'Create Your Listing', desc: 'Step-by-step guide to creating a high-performing listing that attracts serious student enquiries.' },
          { title: 'Pricing Your Property', desc: 'How to set competitive rates based on location, room type, and included amenities.' },
          { title: 'Photo Guide', desc: 'Tips for taking great property photos with just your smartphone.' },
          { title: 'Getting Verified', desc: 'How to get the RentalX Verified badge and why it matters for your booking rate.' },
        ]} />
      </Section>

      <Section title="Downloadable Templates">
        <ul className="list-disc list-inside space-y-2">
          <li>Residential Lease Agreement Template (VIC)</li>
          <li>Residential Lease Agreement Template (NSW)</li>
          <li>Residential Lease Agreement Template (QLD)</li>
          <li>Property Condition Report Template</li>
          <li>Bond Lodgement Checklist</li>
          <li>Move-In / Move-Out Inspection Checklist</li>
        </ul>
        <p className="mt-4 text-sm text-gray-500">Email <strong>landlords@rentalx.com.au</strong> to request any template.</p>
      </Section>

      <Section title="Landlord Webinars">
        <CardGrid items={[
          { title: 'How to Market to International Students', desc: 'Recorded webinar — 45 min · Learn what international students look for and how to make your listing stand out.' },
          { title: 'Understanding Tenancy Law 2026', desc: 'Recorded webinar — 60 min · Key changes to state tenancy laws and what they mean for you.' },
          { title: 'Setting the Right Rent', desc: 'Recorded webinar — 30 min · Data-driven insights on pricing across Australian student suburbs.' },
          { title: 'Managing Student Tenants', desc: 'Recorded webinar — 45 min · Common scenarios, communication tips, and how to handle disputes professionally.' },
        ]} />
      </Section>

      <Section title="Support">
        <p>Our dedicated landlord support team is available Monday–Friday 9am–5pm AEST. Email <strong>landlords@rentalx.com.au</strong> or call <strong>+61 1800 RENTAL</strong>.</p>
      </Section>
    </StaticPage>
  );
}
